export default {
  Report: 'Báo cáo',
  DisplayHide: 'Ẩn hiện báo cáo',
  NotFavorite: 'Bạn chưa có báo cáo yêu thích.',
  ClickStar: 'Ấn vào hình sao bên cạnh báo cáo',
  ClickStarAfter: 'để thêm báo cáo vào mục yêu thích.',
  ReportFavorite: 'Báo cáo yêu thích',
  BCNganSachXa: 'Báo cáo ngân sách xã',
  BCCongKhai: 'Báo cáo công khai',
  BCKhoBac: 'Báo cáo kho bạc',
  BCTaiChinh: 'Báo cáo tài chính',
  SoCai: 'Sổ cái',
  TienMatTienGui: 'Tiền mặt, tiền gửi',
  PhaiThuPhaiTra: 'Phải thu, phải trả',
  VatTuVatLieu: 'Vật tư, vật liệu',
  CongCuDungCu: 'Công cụ, dụng cụ',
  TaiSanCoDinh: 'Tài sản cố định',
  Luong: 'Lương',
  SoChuyenDungHoatDongXa: 'Sổ chuyên dùng cho các hoạt động của xã',
  SoKhac: 'Các loại sổ khác',
  XayDungCoBan: 'Xây dựng cơ bản',
  BCDacThu: 'Báo cáo đặc thù',
  SearchText: 'Tìm kiếm theo tên báo cáo',
  View: 'Xem',
  CoverDesign: 'Thiết kế bìa sổ',
  ReportTemplateWatermark: 'BÁO CÁO MẪU',
  BCND31: 'Báo cáo theo nghị định 31'
};
